export enum SyncAnalysisStatusEnum {
    /** Creado, todavía no empezó a procesarse. */
    Pending = 0,

    /** En ejecución. No puede haber dos en este estado sobre la misma corrida. */
    InProgress = 1,

    /** Terminó y dejó su resumen y sus hallazgos. */
    Completed = 2,

    /** Falló. El detalle queda en errorMessage y la corrida analizada no se ve afectada. */
    Failed = 3,

    /**
     * No se ejecutó porque la verificación previa no encontró indicios de
     * liquidación faltante. Se registra igual para que la ausencia de análisis
     * quede como decisión deliberada y no se confunda con una falla.
     */
    SkippedNoIndicators = 4,
}
